import { Texture as PixiTexture, Sprite as PixiSprite } from 'pixi.js';

export default class Sprite {
  _image: HTMLImageElement | PixiTexture = null;
  public sprite: PixiSprite;
  constructor(image: HTMLImageElement | PixiTexture) {
    this._image = image;
    if (image) {
      if (image instanceof HTMLImageElement) {
        this.sprite = PixiSprite.from(image);
      } else if (image instanceof PixiTexture) {
        this.sprite = new PixiSprite(image);
      }
    } else {
      this.sprite = new PixiSprite();
    }
  }
  set image(val) {
    if (this._image === val) {
      return;
    }

    if (val instanceof HTMLImageElement) {
      this.sprite.texture && this.sprite.texture.destroy(false);
      this.sprite.texture = PixiTexture.from(val);
    } else if (val instanceof PixiTexture) {
      this.sprite.texture = val;
    }
    this._image = val;
  }
  get image() {
    return this._image;
  }
}
